'use client';

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { SearchResultsSkeleton } from './search-results-skeleton.tsx';
import { SearchResults } from './search-results.tsx';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000
    }
  }
});
export const SearchResultsCore = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SearchResultsSkeleton itemCount={9} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Suspense fallback={t0}><QueryClientProvider client={queryClient}><SearchResults /></QueryClientProvider></Suspense>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};